import { render, staticRenderFns } from "./setAuthority.vue?vue&type=template&id=1a7f817a&"
import script from "./setAuthority.vue?vue&type=script&lang=js&"
export * from "./setAuthority.vue?vue&type=script&lang=js&"
import style0 from "./setAuthority.vue?vue&type=style&index=0&id=1a7f817a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports